var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3346 2.83325C9.81964 2.83325 6.16797 6.48492 6.16797 10.9999C6.16797 17.1249 14.3346 26.1666 14.3346 26.1666C14.3346 26.1666 22.5013 17.1249 22.5013 10.9999C22.5013 6.48492 18.8496 2.83325 14.3346 2.83325ZM8.5013 10.9999C8.5013 7.77992 11.1146 5.16659 14.3346 5.16659C17.5546 5.16659 20.168 7.77992 20.168 10.9999C20.168 14.3599 16.808 19.3883 14.3346 22.5266C11.908 19.4116 8.5013 14.3249 8.5013 10.9999Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3346 13.9166C15.9455 13.9166 17.2513 12.6107 17.2513 10.9999C17.2513 9.38909 15.9455 8.08325 14.3346 8.08325C12.7238 8.08325 11.418 9.38909 11.418 10.9999C11.418 12.6107 12.7238 13.9166 14.3346 13.9166Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pin-icon.627ea8e2ac0da5844835193064b1b549.svg";
export { ForwardRef as ReactComponent };